import script from "./MProfileSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfileSkills.vue?vue&type=script&setup=true&lang=js"

import "./MProfileSkills.vue?vue&type=style&index=0&id=1ebda2bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebda2bd"]])

export default __exports__